import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { DeviceType } from 'src/app/models/device-detector.enum';
import { IOHTrainCalloutComponent } from '../ioh-train-callout/ioh-train-callout.component';
import { IOHDeviceDetectorService } from './ioh-device-detector.service';
import { Train } from 'src/app/models/train-info.model';
import { IOHAppService } from 'src/app/services/ioh-app.service';

@Injectable({
  providedIn: 'root'
})
export class IOHDynamicDialogService {
  selectedTrain: Train | undefined;
  ref: DynamicDialogRef | undefined;
  private isTabletView = false;
  isMobileView: boolean = false;
  private dialogState = new BehaviorSubject<{ visible: boolean; data: any }>({
    visible: false,
    data: null
  });

  dialogState$ = this.dialogState.asObservable();
  private destroy$ = new Subject<void>();

  constructor(
    public primeNgDialogService: DialogService,
    private iohDeviceDetectorService: IOHDeviceDetectorService,
    private iohAppService: IOHAppService
  ) {
    this.checkDeviceType();
  }

  showDialog(data): void {
    this.dialogState.next({ visible: true, data });
  }

  hideDialog(): void {
    this.dialogState.next({ visible: false, data: null });
  }

  showTrainCallout(train: any, isWarroom = false) {
    this.selectedTrain = this.resolveTrainDetails(train);
    if (!isWarroom) {
      this.ref = this.primeNgDialogService.open(IOHTrainCalloutComponent, {
        width: this.isMobileView || this.isTabletView ? '95%' : '75%',
        height: this.isTabletView ? '86%' : this.isMobileView ? '95%' : '685px',
        styleClass: 'train-dialog',
        contentStyle: { overflow: 'hidden' },
        maximizable:  this.isMobileView || this.isTabletView ? false : true,
        baseZIndex: 10000,
        showHeader: true,
        dismissableMask: true,
        modal:true,
        closable: true,
        draggable: false,
        resizable: false
      });

      this.ref.onClose.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.selectedTrain = null;
      });
    }
  }

  getSelectedTrain() {
    return this.selectedTrain;
  }

  private resolveTrainDetails(train: any): any {
    if(!train) {
      return train;
    }
    if(this.iohAppService.iohTrainsMap.get(train.trainId)){
      return this.iohAppService.iohTrainsMap.get(train.trainId)
    }else{
      return {
        isTrainIdFlow:true,
        trainId: train.trainId
      }
    } 
  }

  private checkDeviceType(): void {
    const deviceType = this.iohDeviceDetectorService.detectDeviceType();
    switch (deviceType) {
      case DeviceType.Tablet:
        this.isTabletView = true;
        break;
      case DeviceType.Mobile:
        this.isMobileView = true;
        break;
      default:
        this.isTabletView = false;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeTrainCallout() {
    this.ref && this.ref.close();
  }
}
